import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ABOUT, ASSETS } from "@/data/content";
import { Reveal, SectionHead } from "./Reveal";

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="rolunk" ref={ref} className="relative overflow-x-clip py-28 sm:py-36" data-testid="about-section">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-16 px-5 sm:px-8 lg:grid-cols-12 lg:gap-10">
        <div className="lg:col-span-5">
          <SectionHead eyebrow={ABOUT.eyebrow} title={ABOUT.title} testId="about-head" />
          <Reveal delay={0.15}>
            <p className="mt-8 max-w-xl text-base leading-relaxed text-white/60 sm:text-lg" data-testid="about-text">
              {ABOUT.text}
            </p>
          </Reveal>
          <Reveal delay={0.25} className="mt-12 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-white/[0.08] bg-white/[0.06]">
            {ABOUT.facts.map((f) => (
              <div key={f.label} className="bg-[#0f0f11] p-6" data-testid={`about-fact-${f.label.toLowerCase().replace(/\s+/g, '-')}`}>
                <p className="eyebrow mb-3">{f.label}</p>
                <p className="font-display text-xl font-bold text-white sm:text-2xl">{f.value}</p>
              </div>
            ))}
          </Reveal>
        </div>

        <div className="relative lg:col-span-7">
          <Reveal delay={0.1} y={60} className="relative">
            <div className="absolute -inset-10 -z-10 rounded-full bg-[radial-gradient(circle,rgba(94,177,255,0.14),transparent_60%)] blur-3xl" />
            <div className="relative overflow-hidden rounded-[1.75rem] border border-white/[0.08] bg-[#111113] shadow-[0_40px_120px_-40px_rgba(0,0,0,0.9)]">
              <div className="flex items-center gap-2 border-b border-white/[0.06] px-5 py-3">
                <span className="h-2.5 w-2.5 rounded-full bg-white/15" />
                <span className="h-2.5 w-2.5 rounded-full bg-white/15" />
                <span className="h-2.5 w-2.5 rounded-full bg-white/15" />
                <span className="ml-4 font-mono text-[11px] tracking-widest text-white/35">MTA:SA 1.6 — Bone County</span>
              </div>
              <div className="relative aspect-[16/9] overflow-hidden">
                <motion.img
                  style={{ y: imgY, scale: 1.18 }}
                  src={ASSETS.screenshot}
                  alt="Bone County Roleplay játékbeli képernyőkép"
                  className="h-full w-full object-cover"
                  data-testid="about-screenshot"
                />
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#0a0a0b]/70 via-transparent to-transparent" />
              </div>
            </div>
            <motion.img
              src={ASSETS.logo}
              alt=""
              aria-hidden
              initial={{ opacity: 0, rotate: -8, scale: 0.8 }}
              whileInView={{ opacity: 1, rotate: 0, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: 0.4 }}
              className="absolute -bottom-10 -left-6 h-28 w-28 object-contain drop-shadow-[0_20px_40px_rgba(0,0,0,0.7)] sm:-left-10 sm:h-36 sm:w-36"
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
};
